import moment from 'moment';

type CotizacionContratada = {
  clave_empresa: number;
  cliente_contrato: string;
  envio_correo: number;
  fecha_mudanza: string;
  folio_carta_porte: string;
  hora_mudanza: string;
  id_carta_porte: string;
  id_cotizacion_contratada: string;
  id_mm: number;
  id: number;
  nota_interna: string;
  nota_proveedor: string;
  url_pdf: string;
};

const cotizacion_contratada: CotizacionContratada = {
  clave_empresa: 0,
  cliente_contrato: '',
  envio_correo: 0,
  fecha_mudanza: moment().format('YYYY-MM-DD'),
  folio_carta_porte: '',
  hora_mudanza: moment().format('HH:mm'),
  id_carta_porte: '',
  id_cotizacion_contratada: '',
  id_mm: 0,
  id: 0,
  nota_interna: '',
  nota_proveedor: '',
  url_pdf: '',
};

function get_cotizacion_contratada(id_mm = 0): CotizacionContratada {
  const cc: CotizacionContratada = JSON.parse(JSON.stringify(cotizacion_contratada));
  cc.id_mm = id_mm;
  return cc;
}

export {
  get_cotizacion_contratada,
};
